import { render, staticRenderFns } from "./NewsSlider.vue?vue&type=template&id=1b29b979&scoped=true&"
import script from "./NewsSlider.vue?vue&type=script&lang=js&"
export * from "./NewsSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewsSlider.vue?vue&type=style&index=0&id=1b29b979&lang=scss&scoped=true&"
import style1 from "./NewsSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b29b979",
  null
  
)

export default component.exports